"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Green Street Learning Center Proxy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideosApi = exports.VideosApiFactory = exports.VideosApiFp = exports.VideosApiAxiosParamCreator = exports.TechGuidesApi = exports.TechGuidesApiFactory = exports.TechGuidesApiFp = exports.TechGuidesApiAxiosParamCreator = exports.SectorPrimersApi = exports.SectorPrimersApiFactory = exports.SectorPrimersApiFp = exports.SectorPrimersApiAxiosParamCreator = exports.Live101TrainingsApi = exports.Live101TrainingsApiFactory = exports.Live101TrainingsApiFp = exports.Live101TrainingsApiAxiosParamCreator = exports.MethodGuidesApi = exports.MethodGuidesApiFactory = exports.MethodGuidesApiFp = exports.MethodGuidesApiAxiosParamCreator = exports.HintsApi = exports.HintsApiFactory = exports.HintsApiFp = exports.HintsApiAxiosParamCreator = exports.GlossaryApi = exports.GlossaryApiFactory = exports.GlossaryApiFp = exports.GlossaryApiAxiosParamCreator = exports.FoundReportsApi = exports.FoundReportsApiFactory = exports.FoundReportsApiFp = exports.FoundReportsApiAxiosParamCreator = exports.FaqsApi = exports.FaqsApiFactory = exports.FaqsApiFp = exports.FaqsApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 * FaqsApi - axios parameter creator
 * @export
 */
const FaqsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get FAQs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaqs: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/faqs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search FAQs
         * @param {string} s Any keyword to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFaqs: async (s, options = {}) => {
            // verify required parameter 's' is not null or undefined
            (0, common_1.assertParamExists)('searchFaqs', 's', s);
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/faqs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FaqsApiAxiosParamCreator = FaqsApiAxiosParamCreator;
/**
 * FaqsApi - functional programming interface
 * @export
 */
const FaqsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FaqsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get FAQs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaqs(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaqs(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Search FAQs
         * @param {string} s Any keyword to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFaqs(s, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFaqs(s, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.FaqsApiFp = FaqsApiFp;
/**
 * FaqsApi - factory interface
 * @export
 */
const FaqsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FaqsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get FAQs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaqs(options) {
            return localVarFp
                .getFaqs(options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @summary Search FAQs
         * @param {string} s Any keyword to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFaqs(s, options) {
            return localVarFp
                .searchFaqs(s, options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.FaqsApiFactory = FaqsApiFactory;
/**
 * FaqsApi - object-oriented interface
 * @export
 * @class FaqsApi
 * @extends {BaseAPI}
 */
class FaqsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get FAQs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqsApi
     */
    getFaqs(options) {
        return (0, exports.FaqsApiFp)(this.configuration)
            .getFaqs(options)
            .then(request => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search FAQs
     * @param {string} s Any keyword to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FaqsApi
     */
    searchFaqs(s, options) {
        return (0, exports.FaqsApiFp)(this.configuration)
            .searchFaqs(s, options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.FaqsApi = FaqsApi;
/**
 * FoundReportsApi - axios parameter creator
 * @export
 */
const FoundReportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get foundational reports list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoundationalReports: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/foundational-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FoundReportsApiAxiosParamCreator = FoundReportsApiAxiosParamCreator;
/**
 * FoundReportsApi - functional programming interface
 * @export
 */
const FoundReportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FoundReportsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get foundational reports list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFoundationalReports(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFoundationalReports(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.FoundReportsApiFp = FoundReportsApiFp;
/**
 * FoundReportsApi - factory interface
 * @export
 */
const FoundReportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FoundReportsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get foundational reports list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFoundationalReports(options) {
            return localVarFp
                .getFoundationalReports(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.FoundReportsApiFactory = FoundReportsApiFactory;
/**
 * FoundReportsApi - object-oriented interface
 * @export
 * @class FoundReportsApi
 * @extends {BaseAPI}
 */
class FoundReportsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get foundational reports list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoundReportsApi
     */
    getFoundationalReports(options) {
        return (0, exports.FoundReportsApiFp)(this.configuration)
            .getFoundationalReports(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.FoundReportsApi = FoundReportsApi;
/**
 * GlossaryApi - axios parameter creator
 * @export
 */
const GlossaryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get glossary list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlossary: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/glossary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get glossary files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlossaryFiles: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/glossary/pdfs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search Glossary
         * @param {string} s Any keyword to search
         * @param {string} [isFirstLetterSearch] Should you search only the first letter in title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGlossary: async (s, isFirstLetterSearch, options = {}) => {
            // verify required parameter 's' is not null or undefined
            (0, common_1.assertParamExists)('searchGlossary', 's', s);
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/glossary/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }
            if (isFirstLetterSearch !== undefined) {
                localVarQueryParameter['isFirstLetterSearch'] = isFirstLetterSearch;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.GlossaryApiAxiosParamCreator = GlossaryApiAxiosParamCreator;
/**
 * GlossaryApi - functional programming interface
 * @export
 */
const GlossaryApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GlossaryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get glossary list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlossary(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlossary(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get glossary files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlossaryFiles(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlossaryFiles(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Search Glossary
         * @param {string} s Any keyword to search
         * @param {string} [isFirstLetterSearch] Should you search only the first letter in title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGlossary(s, isFirstLetterSearch, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGlossary(s, isFirstLetterSearch, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.GlossaryApiFp = GlossaryApiFp;
/**
 * GlossaryApi - factory interface
 * @export
 */
const GlossaryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GlossaryApiFp)(configuration);
    return {
        /**
         *
         * @summary Get glossary list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlossary(options) {
            return localVarFp
                .getGlossary(options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @summary Get glossary files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlossaryFiles(options) {
            return localVarFp
                .getGlossaryFiles(options)
                .then(request => request(axios, basePath));
        },
        /**
         *
         * @summary Search Glossary
         * @param {string} s Any keyword to search
         * @param {string} [isFirstLetterSearch] Should you search only the first letter in title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGlossary(s, isFirstLetterSearch, options) {
            return localVarFp
                .searchGlossary(s, isFirstLetterSearch, options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.GlossaryApiFactory = GlossaryApiFactory;
/**
 * GlossaryApi - object-oriented interface
 * @export
 * @class GlossaryApi
 * @extends {BaseAPI}
 */
class GlossaryApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get glossary list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    getGlossary(options) {
        return (0, exports.GlossaryApiFp)(this.configuration)
            .getGlossary(options)
            .then(request => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get glossary files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    getGlossaryFiles(options) {
        return (0, exports.GlossaryApiFp)(this.configuration)
            .getGlossaryFiles(options)
            .then(request => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Glossary
     * @param {string} s Any keyword to search
     * @param {string} [isFirstLetterSearch] Should you search only the first letter in title
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlossaryApi
     */
    searchGlossary(s, isFirstLetterSearch, options) {
        return (0, exports.GlossaryApiFp)(this.configuration)
            .searchGlossary(s, isFirstLetterSearch, options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.GlossaryApi = GlossaryApi;
/**
 * HintsApi - axios parameter creator
 * @export
 */
const HintsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get navigational helpful hints list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationalHelpfulHints: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/navigational-helpful-hints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.HintsApiAxiosParamCreator = HintsApiAxiosParamCreator;
/**
 * HintsApi - functional programming interface
 * @export
 */
const HintsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.HintsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get navigational helpful hints list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigationalHelpfulHints(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigationalHelpfulHints(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.HintsApiFp = HintsApiFp;
/**
 * HintsApi - factory interface
 * @export
 */
const HintsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.HintsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get navigational helpful hints list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationalHelpfulHints(options) {
            return localVarFp
                .getNavigationalHelpfulHints(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.HintsApiFactory = HintsApiFactory;
/**
 * HintsApi - object-oriented interface
 * @export
 * @class HintsApi
 * @extends {BaseAPI}
 */
class HintsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get navigational helpful hints list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HintsApi
     */
    getNavigationalHelpfulHints(options) {
        return (0, exports.HintsApiFp)(this.configuration)
            .getNavigationalHelpfulHints(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.HintsApi = HintsApi;
/**
 * MethodGuidesApi - axios parameter creator
 * @export
 */
const MethodGuidesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get methodology quick guidess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMethodologyQuickGuides: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/methodology-quick-guides`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MethodGuidesApiAxiosParamCreator = MethodGuidesApiAxiosParamCreator;
/**
 * MethodGuidesApi - functional programming interface
 * @export
 */
const MethodGuidesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MethodGuidesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get methodology quick guidess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMethodologyQuickGuides(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMethodologyQuickGuides(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MethodGuidesApiFp = MethodGuidesApiFp;
/**
 * MethodGuidesApi - factory interface
 * @export
 */
const MethodGuidesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MethodGuidesApiFp)(configuration);
    return {
        /**
         *
         * @summary Get methodology quick guidess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMethodologyQuickGuides(options) {
            return localVarFp
                .getMethodologyQuickGuides(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.MethodGuidesApiFactory = MethodGuidesApiFactory;
/**
 * MethodGuidesApi - object-oriented interface
 * @export
 * @class MethodGuidesApi
 * @extends {BaseAPI}
 */
class MethodGuidesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get methodology quick guidess
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MethodGuidesApi
     */
    getMethodologyQuickGuides(options) {
        return (0, exports.MethodGuidesApiFp)(this.configuration)
            .getMethodologyQuickGuides(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.MethodGuidesApi = MethodGuidesApi;
/**
 * Live101TrainingsApi - axios parameter creator
 * @export
 */
const Live101TrainingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get Live 101 trainings list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLive101Trainings: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/live-101-trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.Live101TrainingsApiAxiosParamCreator = Live101TrainingsApiAxiosParamCreator;
/**
 * Live101TrainingsApi - functional programming interface
 * @export
 */
const Live101TrainingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.Live101TrainingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Live 101 trainings list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLive101Trainings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLive101Trainings(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.Live101TrainingsApiFp = Live101TrainingsApiFp;
/**
 * Live101TrainingsApi - factory interface
 * @export
 */
const Live101TrainingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.Live101TrainingsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Live 101 trainings list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLive101Trainings(options) {
            return localVarFp
                .getLive101Trainings(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.Live101TrainingsApiFactory = Live101TrainingsApiFactory;
/**
 * Live101TrainingsApi - object-oriented interface
 * @export
 * @class Live101TrainingsApi
 * @extends {BaseAPI}
 */
class Live101TrainingsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get Live 101 trainings list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Live101TrainingsApi
     */
    getLive101Trainings(options) {
        return (0, exports.Live101TrainingsApiFp)(this.configuration)
            .getLive101Trainings(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.Live101TrainingsApi = Live101TrainingsApi;
/**
 * SectorPrimersApi - axios parameter creator
 * @export
 */
const SectorPrimersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get Sector Primers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorPrimers: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/sector-primers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SectorPrimersApiAxiosParamCreator = SectorPrimersApiAxiosParamCreator;
/**
 * SectorPrimersApi - functional programming interface
 * @export
 */
const SectorPrimersApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SectorPrimersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Sector Primers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectorPrimers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectorPrimers(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.SectorPrimersApiFp = SectorPrimersApiFp;
/**
 * SectorPrimersApi - factory interface
 * @export
 */
const SectorPrimersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SectorPrimersApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Sector Primers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorPrimers(options) {
            return localVarFp
                .getSectorPrimers(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.SectorPrimersApiFactory = SectorPrimersApiFactory;
/**
 * SectorPrimersApi - object-oriented interface
 * @export
 * @class SectorPrimersApi
 * @extends {BaseAPI}
 */
class SectorPrimersApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get Sector Primers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectorPrimersApi
     */
    getSectorPrimers(options) {
        return (0, exports.SectorPrimersApiFp)(this.configuration)
            .getSectorPrimers(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.SectorPrimersApi = SectorPrimersApi;
/**
 * TechGuidesApi - axios parameter creator
 * @export
 */
const TechGuidesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get technnical guidess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnicalGuides: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/technical-guides`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TechGuidesApiAxiosParamCreator = TechGuidesApiAxiosParamCreator;
/**
 * TechGuidesApi - functional programming interface
 * @export
 */
const TechGuidesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TechGuidesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get technnical guidess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnicalGuides(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnicalGuides(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.TechGuidesApiFp = TechGuidesApiFp;
/**
 * TechGuidesApi - factory interface
 * @export
 */
const TechGuidesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TechGuidesApiFp)(configuration);
    return {
        /**
         *
         * @summary Get technnical guidess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnicalGuides(options) {
            return localVarFp
                .getTechnicalGuides(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.TechGuidesApiFactory = TechGuidesApiFactory;
/**
 * TechGuidesApi - object-oriented interface
 * @export
 * @class TechGuidesApi
 * @extends {BaseAPI}
 */
class TechGuidesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get technnical guidess
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechGuidesApi
     */
    getTechnicalGuides(options) {
        return (0, exports.TechGuidesApiFp)(this.configuration)
            .getTechnicalGuides(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.TechGuidesApi = TechGuidesApi;
/**
 * VideosApi - axios parameter creator
 * @export
 */
const VideosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get video tutorials and product demos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideos: async (options = {}) => {
            const localVarPath = `/wp-proxy/wp-json/react-news/v1/gs-learning-center/videos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.VideosApiAxiosParamCreator = VideosApiAxiosParamCreator;
/**
 * VideosApi - functional programming interface
 * @export
 */
const VideosApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.VideosApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get video tutorials and product demos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVideos(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVideos(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.VideosApiFp = VideosApiFp;
/**
 * VideosApi - factory interface
 * @export
 */
const VideosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.VideosApiFp)(configuration);
    return {
        /**
         *
         * @summary Get video tutorials and product demos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVideos(options) {
            return localVarFp
                .getVideos(options)
                .then(request => request(axios, basePath));
        },
    };
};
exports.VideosApiFactory = VideosApiFactory;
/**
 * VideosApi - object-oriented interface
 * @export
 * @class VideosApi
 * @extends {BaseAPI}
 */
class VideosApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get video tutorials and product demos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideosApi
     */
    getVideos(options) {
        return (0, exports.VideosApiFp)(this.configuration)
            .getVideos(options)
            .then(request => request(this.axios, this.basePath));
    }
}
exports.VideosApi = VideosApi;
//# sourceMappingURL=api.js.map